import { customMedia } from '@space-core/styles'
import { SectionType } from '@space-shell/common/services/sections/enums'
import styled from 'styled-components'

export const Wrapper = styled.div<{ $sectionType?: SectionType }>`
  padding: 0 var(--spacer-10);

  :hover {
    z-index: 2;
  }

  ${customMedia.lessThan('md')`
     padding: 0 var(--spacer-4);
     overflow: hidden;
  `}

  .swiper,
  .swiper-container,
  .swiper-wrapper {
    overflow: unset;
  }

  .swiper-slide,
  .swiper-virtual,
  .swiper-backface-hidden {
    transform: unset !important;
  }

  .swiper-pagination-bullet {
    width: var(--spacer-3);
    height: var(--spacer-1);
    border-radius: var(--spacer-1);
    background-color: var(--gray-600);
  }

  .swiper-pagination {
    z-index: -1;
    opacity: 0;
    margin-bottom: -10px;
    bottom: ${({ $sectionType }) =>
      $sectionType === SectionType.MODULE ? '-1.875rem !important' : '-1rem !important'};
    transition: opacity var(--timing) var(--easing) calc(var(--timing) / 2);
  }

  .swiper-pagination-bullet-active {
    width: var(--spacer-5);
    background-color: var(--gray-800);
    transition: width 0.8s var(--easing);
  }

  .swiper-button-disabled {
    visibility: hidden;
  }

  .swiper-button-next,
  .swiper-button-prev {
    opacity: 1;
    margin-top: -4rem;
    color: var(--white);
    height: ${({ $sectionType }) => ($sectionType === SectionType.MODULE ? '6.25rem' : '8.75rem')};
    width: var(--spacer-7);
    background-color: rgba(14, 16, 18, 0.9);
    transition: opacity var(--timing) var(--easing) calc(var(--timing) / 2);

    &:after {
      font-size: var(--spacer-5);
    }

    &:hover {
      &:after {
        font-size: var(--spacer-6);
        transition: all var(--timing) var(--easing) calc(var(--timing) / 2);
      }
    }
  }

  .swiper-button-next {
    right: -1.8rem;
    transform: translateX(100%);
    border-top-left-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
    padding-left: 1.18rem;
    padding-right: 1.18rem;

    &:hover {
      right: -0.9rem;
      padding-left: 1.75rem;
      padding-right: 1.75rem;
      transition: all 0.8s var(--easing) calc(var(--timing) / 2);
    }
  }

  .swiper-button-prev {
    left: -1.8rem;
    padding-left: 1.125rem;
    padding-right: 1.125rem;
    transform: translateX(-100%);
    border-top-right-radius: var(--border-radius-lg);
    border-bottom-right-radius: var(--border-radius-lg);

    &:hover {
      left: -0.9rem;
      padding-left: 1.75rem;
      padding-right: 1.75rem;
      transition: all 0.8s var(--easing) calc(var(--timing) / 2);
    }
  }

  &:hover {
    .swiper-button-next,
    .swiper-button-prev,
    .swiper-pagination {
      opacity: 1;
    }
  }
`

export const PreventHover = styled.div<{ $direction: 'prev' | 'next' }>`
  z-index: 1;
  top: 0;
  height: 100%;
  width: 4rem;
  position: absolute;
  ${({ $direction }) =>
    $direction === 'next' ? 'transform: translateX(100%)' : 'transform: translateX(-100%)'};
  ${({ $direction }) => ($direction === 'next' ? 'right: -8px' : 'left: -8px')};
`

export const ContainerCarousel = styled.div`
  overflow-x: clip;
`
